import { errorLoggerWithoutPromise } from 'axios-logger/lib/logger/error'
import { requestLogger, responseLogger } from 'axios-logger'
import { authHandler } from './auth-handler'
import { requestErrorHandler, responseErrorHandler } from './error-handler'
import store from '@/store'
import { modulesName } from '@/store'

export const requestInterceptor = {
  onFulfilled: (config) => {
    // start loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, true)
    authHandler(config)

    return requestLogger(config)
  },

  onRejected: (error) => {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false)
    requestErrorHandler(error)

    return errorLoggerWithoutPromise(error)
  },
}

export const responseInterceptor = {
  onFulfilled(response) {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false)
    return responseLogger(response)
  },

  onRejected(error) {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false)
    responseErrorHandler(error)

    return errorLoggerWithoutPromise(error)
  },
}
